import React from "react";
import { motion } from "framer-motion";
import {
  FaArrowRight,
} from "react-icons/fa";

import healthcareImg from "../assets/medical2.jpeg";
import healthcareImg2 from "../assets/medical3.jpeg";
const Healthcare = () => {
  return (
    <section className="bg-white">

      {/* ================= PAGE HEADER ================= */}

      <div className="bg-[#f8fafc] border-b border-gray-200">

        <div className="max-w-[1450px] mx-auto px-6 py-20">

          <motion.div
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: .7 }}
            className="text-center"
          >

            <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">

              Cambridge International School

            </p>

            <h1 className="text-5xl md:text-7xl font-black text-[#07294d]">

              Healthcare

            </h1>

            <div className="w-28 h-[5px] bg-[#d4af37] rounded-full mx-auto mt-7 mb-8"></div>

            <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-9">

              Promoting the health, safety and well-being of every
              student through quality medical care and a secure
              school environment.

            </p>

          </motion.div>

        </div>

      </div>

      {/* ================= ABOUT HEALTHCARE ================= */}

      <div className="max-w-[1450px] mx-auto px-6 py-24">

        <div className="grid lg:grid-cols-2 gap-20 items-center">

          {/* LEFT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .8 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[30px] shadow-xl">

              <img
                src={healthcareImg}
                alt="Healthcare"
                className="w-full h-[560px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

          {/* RIGHT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .8 }}
            viewport={{ once: true }}
          >

            <span className="uppercase tracking-[5px] text-[#d4af37] font-bold">

              Student Health & Wellness

            </span>

            <h2 className="text-5xl font-black text-[#07294d] leading-tight mt-5 mb-8">

              Caring For Every
              <br />

              Student Every Day

            </h2>

            <div className="w-24 h-[5px] bg-[#d4af37] rounded-full mb-10"></div>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              Cambridge International School provides a
              well-equipped healthcare centre to ensure
              immediate medical assistance whenever required
              during school hours.

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              Qualified nursing staff are available to provide
              first aid, monitor student health and respond
              promptly to any medical emergency.

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-10">

              Our healthcare facilities are designed to create
              a safe, healthy and caring environment where
              every student's well-being remains our highest
              priority.

            </p>

            <button className="inline-flex items-center gap-3 bg-[#07294d] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#0b3d69] transition">

              Learn More

              <FaArrowRight />

            </button>

          </motion.div>

        </div>

      </div>
            {/* ================= MEDICAL FACILITIES ================= */}

      <section className="py-24 bg-[#f8fafc]">

        <div className="max-w-[1450px] mx-auto px-6">

          <div className="text-center mb-20">

            <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">

              Medical Facilities

            </p>

            <h2 className="text-5xl font-black text-[#07294d]">

              Student Health Services

            </h2>

            <div className="w-24 h-[5px] bg-[#d4af37] rounded-full mx-auto mt-6"></div>

          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">

            {[
              {
                icon: "🏥",
                title: "Healthcare Centre",
                desc: "A clean and well-equipped healthcare room is available to provide immediate medical attention during school hours."
              },
              {
                icon: "👩‍⚕️",
                title: "Qualified Nurse",
                desc: "Experienced nursing staff provide first aid, health monitoring and emergency support whenever required."
              },
              {
                icon: "🚑",
                title: "Emergency Care",
                desc: "Prompt medical assistance is available to ensure every student's safety and well-being."
              },
              {
                icon: "❤️",
                title: "Student Wellness",
                desc: "Regular care and a healthy environment help students remain active, safe and focused on learning."
              }
            ].map((item, index) => (

              <motion.div
                key={index}
                whileHover={{ y: -8 }}
                className="bg-white rounded-[28px] shadow-lg border border-gray-100 p-8 transition duration-300"
              >

                <div className="w-16 h-16 rounded-2xl bg-[#07294d] text-white flex items-center justify-center text-3xl mb-6">

                  {item.icon}

                </div>

                <h3 className="text-2xl font-bold text-[#07294d] mb-4">

                  {item.title}

                </h3>

                <div className="w-14 h-[4px] bg-[#d4af37] rounded-full mb-5"></div>

                <p className="text-gray-600 leading-8">

                  {item.desc}

                </p>

              </motion.div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= EMERGENCY SUPPORT ================= */}

      <section className="py-24 bg-white">

        <div className="max-w-[1450px] mx-auto px-6">

          <div className="grid lg:grid-cols-2 gap-20 items-center">

            {/* LEFT CONTENT */}

            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: .8 }}
              viewport={{ once: true }}
            >

              <span className="uppercase tracking-[5px] text-[#d4af37] font-bold">

                Emergency Support

              </span>

              <h2 className="text-5xl font-black text-[#07294d] mt-5 mb-8">

                Immediate Care
                <br />

                When Needed

              </h2>

              <div className="w-24 h-[5px] bg-[#d4af37] rounded-full mb-10"></div>

              <p className="text-gray-600 text-lg leading-9 mb-8">

                Student health and safety remain our highest priority.
                Our healthcare team responds quickly to medical needs,
                ensuring students receive prompt attention and appropriate care.

              </p>

              <div className="space-y-5">

                {[
                  "Well-equipped First Aid Facility",
                  "Qualified Nursing Assistance",
                  "Immediate Emergency Response",
                  "Healthy & Safe School Environment",
                ].map((item, index) => (

                  <div
                    key={index}
                    className="flex items-center gap-4"
                  >

                    <div className="w-10 h-10 rounded-full bg-[#d4af37] text-white flex items-center justify-center font-bold">

                      ✓

                    </div>

                    <p className="text-[#07294d] text-lg font-medium">

                      {item}

                    </p>

                  </div>

                ))}

              </div>

            </motion.div>

            {/* RIGHT IMAGE */}

            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: .8 }}
              viewport={{ once: true }}
            >

              <img
                src={healthcareImg2}
                alt="Healthcare"
                className="w-full h-[520px] rounded-[30px] object-cover shadow-xl"
              />

            </motion.div>

          </div>

        </div>

      </section>
            {/* ================= HEALTH & WELLNESS ================= */}

      <section className="py-24 bg-[#07294d]">

        <div className="max-w-[1450px] mx-auto px-6">

          <div className="rounded-[35px] bg-white p-14 shadow-[0_20px_60px_rgba(0,0,0,.08)]">

            <div className="grid lg:grid-cols-2 gap-16 items-center">

              {/* LEFT */}

              <div>

                <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-5">

                  Cambridge International School

                </p>

                <h2 className="text-5xl font-black text-[#07294d] leading-tight mb-8">

                  Healthy Students,
                  <br />

                  Happy Learning

                </h2>

                <p className="text-gray-600 text-lg leading-9 mb-10">

                  A healthy child learns better. Our healthcare facilities,
                  trained nursing staff and student-focused care ensure a
                  safe and supportive environment where every child can
                  learn with confidence.

                </p>

                <button className="px-10 py-4 rounded-full bg-[#07294d] text-white font-semibold hover:bg-[#0d3d69] transition">

                  Contact School

                </button>

              </div>

              {/* RIGHT */}

              <div className="grid grid-cols-2 gap-6">

                <div className="bg-[#f8fafc] rounded-[25px] p-8 text-center">

                  <h3 className="text-5xl font-black text-[#07294d]">

                    24×7

                  </h3>

                  <p className="text-gray-600 mt-3">

                    Emergency Support

                  </p>

                </div>

                <div className="bg-[#f8fafc] rounded-[25px] p-8 text-center">

                  <h3 className="text-5xl font-black text-[#07294d]">

                    Nurse

                  </h3>

                  <p className="text-gray-600 mt-3">

                    Qualified Staff

                  </p>

                </div>

                <div className="bg-[#f8fafc] rounded-[25px] p-8 text-center">

                  <h3 className="text-5xl font-black text-[#07294d]">

                    Care

                  </h3>

                  <p className="text-gray-600 mt-3">

                    Student Well-being

                  </p>

                </div>

                <div className="bg-[#f8fafc] rounded-[25px] p-8 text-center">

                  <h3 className="text-5xl font-black text-[#07294d]">

                    Safe

                  </h3>

                  <p className="text-gray-600 mt-3">

                    School Environment

                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

    </section>
  );
};

export default Healthcare;